import {useEffect, useState} from "react";
import {isAuthenticated} from "../apicalls/auth";
import {getTotalCoaches} from "../apicalls/coaches";
import {getTotalLocations} from "../apicalls/locations";
import {getTotalPlayers} from "../apicalls/players";
import {getAllTransactionsTotal} from "../apicalls/transaction";
import "./style/Dashboard.css";

function Dashboard() {
  const user = isAuthenticated();
  const accessToken = user?.access_token;

  const [coaches, setCoaches] = useState([]);
  const [players, setPlayers] = useState([]);
  const [locations, setLocations] = useState([]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (!accessToken) {
      return;
    }

    getTotalCoaches(accessToken).then((data) => setCoaches(data));
    getTotalPlayers(accessToken).then((data) => setPlayers(data));
    getTotalLocations(accessToken).then((data) => setLocations(data));
    getAllTransactionsTotal(accessToken).then((data) =>
      setTotal(data?.Balance)
    );
  }, [accessToken]);

  return (
    <main>
      <h1>Dashboard</h1>
      <div className="row">
        <div className="col-lg-2 col-md-6 col-sm-12 shadow p-3 mb-5 bg-white rounded">
          <h2 className="text-center">{coaches?.length}</h2>

          <h2 className="text-center">Coaches</h2>
        </div>
        <div className="col-lg-2 col-md-6 col-sm-12  shadow p-3 mb-5 bg-white rounded">
          <h2 className="text-center">{players?.length}</h2>

          <h2 className="text-center">Players</h2>
        </div>
        <div className="col-lg-2 col-md-6 col-sm-12  shadow p-3 mb-5 bg-white rounded">
          <h2 className="text-center">{locations?.length}</h2>

          <h2 className="text-center">Locations</h2>
        </div>
        <div className="col-lg-2 col-md-6 col-sm-12  shadow p-3 mb-5 bg-white rounded">
          <h2 className="text-center">$ {total}</h2>

          <h2 className="text-center">Total Balance</h2>
        </div>
      </div>
    </main>
  );
}

export default Dashboard;
